(() => {
  const initializeProduct = (root) => {
    if (!root || root.dataset.marsantsxProductReady === "true") return;
    root.dataset.marsantsxProductReady = "true";

    const galleryImage = root.querySelector("[data-p4-gallery-main]");
    const galleryThumbs = [...root.querySelectorAll("[data-p4-gallery-thumb]")];
    const colorButtons = [...root.querySelectorAll("[data-p4-color-src]")];
    const productName = root.dataset.productName || "Light-P4";
    const priceNode = root.querySelector("[data-p4-price]");
    const colorName = root.querySelector("[data-p4-color-name]");
    const colorLegend = root.querySelector("[data-p4-color-legend]");

    const setGalleryImage = (src, alt, activeThumb = null) => {
      if (!galleryImage || !src) return;
      galleryThumbs.forEach((thumb) => thumb.classList.toggle("is-active", thumb === activeThumb));
      galleryImage.classList.add("is-changing");
      window.setTimeout(() => {
        galleryImage.removeAttribute("srcset");
        galleryImage.removeAttribute("sizes");
        galleryImage.src = src;
        galleryImage.alt = alt || `${productName} 商品画像`;
        if (galleryImage.complete) galleryImage.classList.remove("is-changing");
      }, 90);
      galleryImage.addEventListener("load", () => galleryImage.classList.remove("is-changing"), { once: true });
    };

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        setGalleryImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt, thumb);
      });
    });

    colorButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setGalleryImage(
          button.dataset.p4ColorSrc,
          `${button.dataset.p4ColorJp || "選択色"}の${productName}`,
          galleryThumbs[0] || null,
        );
      });
    });

    const addButton = root.querySelector("[data-p4-add-to-cart]");
    const buyButton = root.querySelector("[data-p4-buy-now]");
    const variantMapNode = root.querySelector("[data-p4-variant-map]");
    let selectedVariantId = addButton?.dataset.defaultVariant || "";
    let selectedColor = colorButtons.find((button) => button.classList.contains("is-active"));
    let variantMap = [];

    try {
      variantMap = variantMapNode ? JSON.parse(variantMapNode.textContent) : [];
    } catch (_error) {
      variantMap = [];
    }

    const syncVariant = (button) => {
      selectedColor = button || selectedColor;
      if (!selectedColor || !variantMap.length) return;
      const exactVariant = selectedColor.dataset.variantId
        ? variantMap.find((variant) => String(variant.id) === selectedColor.dataset.variantId)
        : null;
      const names = [selectedColor.dataset.p4Color, selectedColor.dataset.p4ColorJp]
        .filter(Boolean)
        .map((name) => name.toLowerCase());
      const match = exactVariant || variantMap.find((variant) => {
        const title = String(variant.title || "").toLowerCase();
        return names.some((name) => title.includes(name));
      });
      if (!match) return;
      selectedVariantId = String(match.id);
      if (priceNode && match.price) priceNode.textContent = match.price;
      if (colorName) colorName.textContent = selectedColor.dataset.p4ColorJp || selectedColor.dataset.p4Color;
      if (colorLegend) colorLegend.textContent = selectedColor.dataset.p4ColorJp || selectedColor.dataset.p4Color;
      const isAvailable = Boolean(match.available);
      if (addButton) {
        addButton.disabled = !isAvailable;
        const label = addButton.querySelector("span");
        if (label) label.textContent = isAvailable ? "カートに追加" : "売り切れ";
      }
      if (buyButton) {
        buyButton.disabled = !isAvailable;
        const label = buyButton.querySelector("span");
        if (label) label.textContent = isAvailable ? "今すぐ購入" : "売り切れ";
      }
    };

    colorButtons.forEach((button) => {
      button.addEventListener("click", () => {
        colorButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", String(isActive));
        });
        syncVariant(button);
      });
    });
    syncVariant(selectedColor);

    const input = root.querySelector("[data-p4-quantity]");
    const minus = root.querySelector("[data-quantity-minus]");
    const plus = root.querySelector("[data-quantity-plus]");
    if (!input) return;

    const clamp = (value) => Math.max(1, Math.min(10, Number.parseInt(value || "1", 10) || 1));
    const setQuantity = (value) => {
      input.value = String(clamp(value));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    minus?.addEventListener("click", () => setQuantity(Number(input.value) - 1));
    plus?.addEventListener("click", () => setQuantity(Number(input.value) + 1));
    input.addEventListener("change", () => setQuantity(input.value));

    const addSelectedItem = async (button, redirectTo, loadingLabel) => {
      if (!button || !selectedVariantId || button.disabled) return;
      const label = button.querySelector("span");
      const originalLabel = label?.textContent || "カートに追加";
      addButton?.setAttribute("disabled", "");
      buyButton?.setAttribute("disabled", "");
      button.classList.add("is-loading");
      if (label) label.textContent = loadingLabel;

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{
              id: Number(selectedVariantId),
              quantity: clamp(input.value),
              properties: { "カラー": selectedColor?.dataset.p4ColorJp || selectedColor?.dataset.p4Color || "カラー" },
            }],
          }),
        });
        if (!response.ok) throw new Error("商品をカートに追加できませんでした");
        window.location.assign(redirectTo);
      } catch (_error) {
        button.classList.add("is-error");
        if (label) label.textContent = "もう一度お試しください";
        window.setTimeout(() => {
          button.classList.remove("is-error");
          if (label) label.textContent = originalLabel;
        }, 2200);
      } finally {
        addButton?.removeAttribute("disabled");
        buyButton?.removeAttribute("disabled");
        button.classList.remove("is-loading");
      }
    };

    buyButton?.addEventListener("click", () => addSelectedItem(buyButton, "/checkout", "購入手続きへ…"));
    addButton?.addEventListener("click", () => addSelectedItem(addButton, "/cart", "追加中…"));
  };

  const initializeAll = () => {
    document.querySelectorAll("[data-marsantsx-product]").forEach(initializeProduct);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener("shopify:section:load", initializeAll);
})();
